// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"082383f7fea98697fded","655":"ea1d87f32bd80b182640"}[chunkId] + ".js";
};